import React, { useMemo, useState } from "react";
import { Modal } from "../Modal";
import { getValue } from "../../utils/object.utils";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { TransportForm } from "./TransportForm";
import { useUpdateTransport } from "../../hooks/transportHook/transport.hooks";

interface Props {
  selectedTransport: any;
  open: boolean;
  onClose: () => unknown;
}
export const EditTransportModal = ({
  selectedTransport,
  open,
  onClose,
}: Props) => {
  const dispatch = useDispatch();

  const [routeName, setRouteName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [licenseNo, setLicenseNo] = useState("");
  const [driverName, setDriverName] = useState("");
  const [driverContact, setDriverContact] = useState("");
  const [transportCode, setTransportCode] = useState("");

  const { isLoading: isTransportUpdating, mutate: updateTransport } =
    useUpdateTransport({
      onSuccess: () => {
        dispatch(setSuccessMessage("Transport updated successfully."));
        onClose();
      },
      onError: (error: Error) => {
        dispatch(setErrorMessage(parseApiError(error)));
      },
    });

  const handleTransportUpdate = () => {
    if (!transportCode) {
      return dispatch(setWarningMessage("Please enter block name"));
    }

    if (!routeName) {
      return dispatch(setWarningMessage("Please select branch."));
    }

    const transportId = getValue(selectedTransport, "id");

    if (!transportId) return null;

    updateTransport({
      transportId,
      body: {
        transport_code: transportCode,
        route_name: routeName,
        vehicle_no: vehicleNo,
        driver_name: driverName,
        driver_contact: driverContact,
        driver_license: licenseNo,
      },
    });
  };

  useMemo(() => {
    const routeName = getValue(selectedTransport, "routeName", "");
    const vehicleNo = getValue(selectedTransport, "vehicleNo", "");
    const licenseNo = getValue(selectedTransport, "licenseNo", "");
    const driverName = getValue(selectedTransport, "driverName", "");
    const driverContact = getValue(selectedTransport, "driverContact", "");
    const transportCode = getValue(selectedTransport, "transportCode", "");

    setRouteName(routeName);
    setVehicleNo(vehicleNo);
    setLicenseNo(licenseNo);
    setDriverName(driverName);
    setDriverContact(driverContact);
    setTransportCode(transportCode);
  }, [selectedTransport]);

  return (
    <Modal
      show={open}
      onClose={onClose}
      modalHeader="Edit block"
      submissionButton={{
        text: "Save",
        onClick: () => {
          handleTransportUpdate();
        },
        isSubmitLoading: isTransportUpdating,
      }}
    >
      <TransportForm
        vehicleNo={vehicleNo}
        setVehicleNo={setVehicleNo}
        licenseNo={licenseNo}
        setLicenseNo={setLicenseNo}
        driverName={driverName}
        setDriverName={setDriverName}
        driverContact={driverContact}
        setDriverContact={setDriverContact}
        transportCode={transportCode}
        setTransportCode={setTransportCode}
        routeName={routeName}
        setRouteName={setRouteName}
      />
    </Modal>
  );
};
